"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigName = void 0;
/**
 * Interface to define a specific configuration to query.
 *
 * Each configuration type will have it's own implementation,
 * providing enum values of available configurations to query.
 */
class ConfigName {
    constructor(_name, _returnType) {
        this._name = _name;
        this._returnType = _returnType;
    }
    /**
     * Defines what type of data will be return from the configuration query.
     * This method can be used as a helper to identify how to read the response data.
     *
     * @return {@link DataType}
     */
    getReturnType() {
        return this._returnType;
    }
    /**
     * Return the printable string of this ConfigName
     */
    toString() {
        return this._name;
    }
}
exports.ConfigName = ConfigName;
//# sourceMappingURL=config-name.js.map